import request from '@/utils/http';
// 整改任务列表
export const rectifyList = (data) => {
    return request({
        url: `/api-srm-web/performance/portal/performanceRectificationTasksManagerPage`,
        method: 'post',
        data
    });
};
// 证明文件
export const fileList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidModuleFile/getBidModuleFiles`,
        method: 'post',
        data: params
    });
};
// 审核
export const examineConfirm = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/rectificationTasks`,
        method: 'post',
        data: params
    });
};
// --------------工作台--------------
// 列表查询
export const workTaskList = (data) => {
    return request({
        url: `/api-srm-web/performance/portal/workbenchTasksManagerPage`,
        method: 'post',
        data
    });
};
// 提交
export const rectifySubmit = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/rectificationTasks`,
        method: 'post',
        data: params
    });
};
// 下发
export const issueApi = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/batchIssueTask`,
        method: 'post',
        data: params
    });
};
